import { render } from "./OuterMetadataInputPage.vue?vue&type=template&id=3e7460ca&scoped=true&ts=true"
import script from "./OuterMetadataInputPage.vue?vue&type=script&lang=ts"
export * from "./OuterMetadataInputPage.vue?vue&type=script&lang=ts"

import "./OuterMetadataInputPage.vue?vue&type=style&index=0&id=3e7460ca&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7460ca"]])

export default __exports__